(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apple-bento-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    const sections = document.querySelectorAll('.apple-bento');
    
    sections.forEach(section => {
      // Header fade
      const header = section.querySelector('.apple-bento__header');
      if (header) {
        gsap.fromTo(header, {
          y: 40,
          opacity: 0
        }, {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: header,
            start: "top 85%",
            toggleActions: "play none none none"
          }
        });
      }

      // Bento Items Stagger
      const items = section.querySelectorAll('.gsap-bento-reveal');
      if (items.length > 0) {
        gsap.fromTo(items, {
          y: 60,
          opacity: 0,
          scale: 0.95
        }, {
          y: 0,
          opacity: 1,
          scale: 1,
          duration: 0.8,
          stagger: 0.1,
          ease: "back.out(1.2)",
          scrollTrigger: {
            trigger: section.querySelector('.apple-bento__grid'),
            start: "top 80%",
            toggleActions: "play none none none"
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apple-feature-split"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    const sections = document.querySelectorAll('.apple-feature-split');
    
    sections.forEach(section => {
      const media = section.querySelector('.gsap-split-media');
      const textContent = section.querySelector('.gsap-split-text');
      const parallaxImage = section.querySelector('.gsap-parallax-image');

      // Media fade/slide in
      if (media) {
        gsap.fromTo(media, {
          y: 60,
          opacity: 0
        }, {
          y: 0,
          opacity: 1,
          duration: 1.2,
          ease: "power2.out",
          scrollTrigger: {
            trigger: section,
            start: "top 80%",
            toggleActions: "play none none reverse"
          }
        });
      }

      // Parallax effect on the image itself
      if (parallaxImage) {
         gsap.to(parallaxImage, {
           yPercent: 15,
           ease: "none",
           scrollTrigger: {
             trigger: section,
             start: "top bottom",
             end: "bottom top",
             scrub: true
           }
         });
      }

      // Text fade in
      if (textContent) {
        gsap.fromTo(textContent.children, {
          y: 30,
          opacity: 0
        }, {
          y: 0,
          opacity: 1,
          duration: 0.8,
          stagger: 0.15,
          ease: "power2.out",
          scrollTrigger: {
            trigger: section,
            start: "top 75%",
            toggleActions: "play none none reverse"
          }
        });
      }

      // Accordion interactivity
      const accordions = section.querySelectorAll('.apple-feature-split__accordion');
      accordions.forEach(acc => {
        const btn = acc.querySelector('.apple-feature-split__accordion-btn');
        const wrapper = acc.querySelector('.apple-feature-split__accordion-content-wrapper');
        if(btn && wrapper) {
          btn.addEventListener('click', () => {
             const isOpen = wrapper.classList.contains('is-open');
             if(isOpen) {
               wrapper.classList.remove('is-open');
               btn.classList.remove('is-open');
               btn.setAttribute('aria-expanded', 'false');
             } else {
               wrapper.classList.add('is-open');
               btn.classList.add('is-open');
               btn.setAttribute('aria-expanded', 'true');
             }
          });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curtis-builder-profile"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-builder-more]');
    if (!button) return;
    const text = document.getElementById(button.getAttribute('aria-controls'));
    const open = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', String(open));
    text?.classList.toggle('is-open', open);
    const label = button.querySelector('[data-builder-more-label]');
    if (label) label.textContent = open ? 'Show less' : 'Read more';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curtis-geometry-fit"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const option = event.target.closest('[data-fit-option]');
    if (!option) return;
    const toggle = option.closest('[data-fit-toggle]');
    toggle.querySelectorAll('[data-fit-option]').forEach((button) => {
      const chosen = button === option;
      button.setAttribute('aria-selected', String(chosen));
      document.getElementById(button.getAttribute('aria-controls'))?.classList.toggle('is-selected', chosen);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curtis-range-explorer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('curtis-range')) {
    customElements.define('curtis-range', class extends HTMLElement {
      // Pieces held invisible until the opening reveal plays
      static staged = '.curtis-range__piece';
      // One curve for lifting a model off the table and setting it back: slow away, slow arrival
      static lift = 'cubic-bezier(.76,0,.24,1)';
      static settle = 'cubic-bezier(.16,1,.3,1)';
      // Quick to respond, long gentle landing: the curve for the card's journey into its discipline
      static glide = 'cubic-bezier(.32,.72,0,1)';
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.triggers = [...this.querySelectorAll('[data-range-trigger]')];
        this.panels = [...this.querySelectorAll('.curtis-range__panel')];
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.phone = matchMedia('(max-width: 749px)');
        this.groupsEl = this.querySelector('.curtis-range__groups');
        this.intro = this.querySelector('[data-range-intro]');
        this.nav = this.querySelector('[data-range-nav]');
        this.tabs = [...this.querySelectorAll('[data-range-tab]')];
        this.handles = this.triggers.map(trigger => trigger.dataset.rangeHandle);
        this.morphVersion = 0;
        this.photoTiles = this.classList.contains('curtis-range--photo-tiles');
        this.panels.forEach(panel => { panel.hidden = true; });
        this.triggers.forEach((trigger, index) => {
          trigger.setAttribute('role', 'button');
          trigger.setAttribute('aria-expanded', 'false');
          trigger.setAttribute('aria-controls', this.panels[index].id);
          trigger.addEventListener('click', event => { event.preventDefault(); this.go(index); }, options);
          trigger.addEventListener('keydown', event => { if (event.key === ' ') { event.preventDefault(); this.go(index); } }, options);
          // Intent: start fetching a discipline's photos the moment a visitor shows interest in its card
          ['pointerenter', 'pointerdown', 'focus'].forEach(type => trigger.addEventListener(type, () => this.warm(index), options));
        });
        this.watchApproach();
        this.setupStage(options);
        this.setupDeck(options);
        this.tabs.forEach((tab, index) => tab.addEventListener('click', event => {
          event.preventDefault();
          // The open discipline's own name takes you back to its models
          if (index === this.active && this.stageOpen) this.closeStage();
          else this.go(index);
        }, options));
        this.backLabel = this.querySelector('[data-range-back-label]');
        // One back link that always steps up a level: from a model to its discipline, from a discipline to all of them
        this.querySelector('[data-range-back]')?.addEventListener('click', () => { if (this.stageOpen) this.closeStage(); else this.go(null); }, options);
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          if (this.stageOpen) { event.preventDefault(); this.closeStage(); }
          else if (this.active != null) { event.preventDefault(); this.go(null); }
        }, options);
        // The address carries the open discipline (#range-gravel), so Back, Forward and shared links all work
        window.addEventListener('popstate', () => this.syncFromHash(), options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.triggers.findIndex(trigger => trigger === event.target || trigger.contains(event.target));
          if (index >= 0) this.show(index, { instant: true });
        }, options);
        const initial = this.indexFromHash();
        if (initial != null) {
          this.show(initial, { instant: true });
          requestAnimationFrame(() => this.scrollIntoView({ block: 'start', behavior: 'instant' }));
        }
        this.completedCards = new Set();
        this.addEventListener('focusin', event => {
          const card = event.target.closest('[data-range-trigger]');
          if (card) this.revealCard(card);
        }, options);
        this.addEventListener('shopify:section:select', () => this.revealAll(), options);
        this.reduced.addEventListener('change', () => this.setupEntrance(), options);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.scheduleEntrance(), { ...options, once: true });
        } else {
          this.scheduleEntrance();
        }
      }
      scheduleEntrance() {
        cancelAnimationFrame(this.entranceFrame);
        this.entranceFrame = requestAnimationFrame(() => {
          if (this.isConnected) this.setupEntrance();
        });
      }
      revealCard(card) {
        this.entranceTimelines?.forEach(timeline => {
          if (timeline.getChildren().some(tween => tween.targets?.().includes(card))) {
            timeline.progress(1);
          }
        });
        this.completedCards.add(card);
        card.style.visibility = 'visible';
        card.style.opacity = '1';
        card.style.transform = 'none';
      }
      revealAll() {
        this.stopEntrance();
        this.triggers.forEach(card => this.revealCard(card));
      }
      stopEntrance() {
        clearTimeout(this.libraryTimer);
        this.motion?.revert();
        this.motion = null;
        this.entranceTimelines = [];
      }
      setupEntrance() {
        this.stopEntrance();
        if (this.reduced.matches) {
          this.triggers.forEach(card => this.revealCard(card));
          return;
        }
        const gsap = window.gsap;
        const ScrollTrigger = window.ScrollTrigger;
        if (!gsap || !ScrollTrigger) {
          if ((this.libraryAttempts || 0) < 50) {
            this.libraryAttempts = (this.libraryAttempts || 0) + 1;
            this.libraryTimer = setTimeout(() => { if (this.isConnected) this.setupEntrance(); }, 100);
          }
          return;
        }
        this.libraryAttempts = 0;
        try {
          gsap.registerPlugin(ScrollTrigger);
          this.motion = gsap.matchMedia();
          this.motion.add({ desktop: '(min-width: 750px)', mobile: '(max-width: 749px)' }, context => {
            const header = this.querySelector('.curtis-range__header');
            // The heading's own word-by-word fade comes from .curtis-xl-heading; this timeline only paces the intro and cards
            const heading = header.querySelector('h2');
            const grid = this.querySelector('.curtis-range__groups');
            const desktop = context.conditions.desktop;
            const cards = this.triggers.filter(card => !this.completedCards.has(card));

            // Cards wait for the header's cue, so the order is always heading -> subheading -> cards,
            // even if a fast scroll brings the grid into view first.
            let headerReady = !heading;
            const waiting = [];
            const release = timeline => headerReady ? timeline.play() : waiting.push(timeline);

            if (heading) {
              const headerTimeline = gsap.timeline({
                scrollTrigger: { trigger: header, start: 'top 82%', once: true }
              });
              // The intro fades as a follower of the XL heading (assets/curtis-xl-heading.js)
              headerTimeline
                // TODO(human): choose when the cards may begin (timeline position, seconds)
                .call(() => { headerReady = true; waiting.splice(0).forEach(timeline => timeline.play()); }, null, .9);
            }

            if (!cards.length) return;
            // Desktop: one staggered row keyed to the grid. Mobile: stacked, so each card keys to itself.
            const groups = desktop ? [cards] : cards.map(card => [card]);
            groups.forEach(group => {
              const timeline = gsap.timeline({
                paused: true,
                onComplete: () => group.forEach(card => this.completedCards.add(card))
              });
              group.forEach((card, index) => {
                const offset = index * (desktop ? .14 : 0);
                timeline.fromTo(card, { autoAlpha: 0 }, { autoAlpha: 1, duration: .7, ease: 'power1.out' }, offset);
                timeline.fromTo(card, { y: desktop ? 56 : 32 }, { y: 0, duration: 1.1, ease: 'expo.out' }, offset);
              });
              ScrollTrigger.create({
                trigger: desktop ? grid : group[0],
                start: desktop ? 'top 88%' : 'top 90%',
                once: true,
                refreshPriority: -10,
                onEnter: () => release(timeline)
              });
              this.entranceTimelines.push(timeline);
            });
          });
          requestAnimationFrame(() => { if (this.isConnected && this.motion) ScrollTrigger.refresh(); });
        } catch (error) {
          this.revealAll();
        }
      }
      // Phones: the discipline cards are a horizontal swipe deck. Keep the dots and count in step with it,
      // and let the arrow buttons move through it for anyone who doesn't swipe.
      setupDeck(options) {
        const nav = this.querySelector('[data-deck-nav]');
        const deck = this.groupsEl;
        if (!nav || !deck) return;
        const slots = [...deck.querySelectorAll('.curtis-range__slot')];
        const dots = [...nav.querySelectorAll('[data-deck-dot]')];
        const count = nav.querySelector('[data-deck-count]');
        const [prev, next] = [...nav.querySelectorAll('[data-deck-step]')];
        const current = () => {
          const start = deck.scrollLeft;
          let best = 0;
          slots.forEach((slot, i) => {
            if (Math.abs(slot.offsetLeft - slots[0].offsetLeft - start) < Math.abs(slots[best].offsetLeft - slots[0].offsetLeft - start)) best = i;
          });
          return best;
        };
        let frame = 0;
        const sync = () => {
          frame = 0;
          const index = current();
          dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
          if (count) count.textContent = `${index + 1} / ${slots.length}`;
          prev.disabled = index === 0;
          next.disabled = index === slots.length - 1;
        };
        deck.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(sync); }, { ...options, passive: true });
        nav.addEventListener('click', event => {
          const button = event.target.closest('[data-deck-step]');
          if (!button) return;
          const target = slots[Math.min(slots.length - 1, Math.max(0, current() + Number(button.dataset.deckStep)))];
          deck.scrollTo({ left: target.offsetLeft - slots[0].offsetLeft, behavior: this.reduced.matches ? 'instant' : 'smooth' });
        }, options);
        sync();
      }
      scrollIfNeeded(element) {
        const bounds = element.getBoundingClientRect();
        if (bounds.top < 100 || bounds.top > window.innerHeight - 120) {
          element.scrollIntoView({ behavior: this.reduced.matches ? 'instant' : 'smooth', block: 'start' });
        }
      }

      /* ---------- Loading ---------- */

      tilesIn(panel) {
        return [...panel.querySelectorAll('[data-piece]')];
      }
      // Swap a tile's deferred srcset in and resolve once the photo is decoded (memoised per tile)
      load(tile) {
        if (!tile) return Promise.resolve();
        this.loads ||= new WeakMap();
        if (this.loads.has(tile)) return this.loads.get(tile);
        const img = tile.querySelector('img[data-srcset]');
        let loading = Promise.resolve();
        if (img) {
          img.srcset = img.dataset.srcset;
          img.src = img.dataset.src;
          img.removeAttribute('data-srcset');
          img.removeAttribute('data-src');
          loading = this.ready(img).catch(() => {});
        }
        loading = loading.then(() => { tile.dataset.loaded = ''; });
        this.loads.set(tile, loading);
        return loading;
      }
      warm(index) {
        const panel = this.panels[index];
        if (panel) this.tilesIn(panel).forEach(tile => this.load(tile));
      }
      // As the section approaches, fetch every blurred placeholder (around 1 KB each). On touch screens,
      // where there is no hover to read intent from, a card that settles in view warms its table.
      watchApproach() {
        this.approach = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.approach.disconnect();
          this.querySelectorAll('[data-lqip]').forEach(el => { new Image().src = el.dataset.lqip; });
        }, { rootMargin: '100% 0px' });
        this.approach.observe(this);
        if (matchMedia('(hover: none)').matches) {
          this.cardWatcher = new IntersectionObserver(entries => entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.cardWatcher.unobserve(entry.target);
            this.warm(this.triggers.indexOf(entry.target));
          }), { threshold: 0.6 });
          this.triggers.forEach(trigger => this.cardWatcher.observe(trigger));
        }
      }

      /* ---------- Disciplines: the in-place morph ---------- */

      cancelPanelMotion() {
        this.panels.forEach(panel => {
          panel.getAnimations({ subtree: true }).forEach(animation => animation.cancel());
          panel.querySelectorAll(this.constructor.staged).forEach(el => { el.style.opacity = ''; });
        });
      }
      indexFromHash() {
        const match = location.hash.match(/^#range-(.+)$/);
        if (!match) return null;
        const index = this.handles.indexOf(decodeURIComponent(match[1]));
        return index >= 0 ? index : null;
      }
      // What the visitor asked for: opening from the cards adds a history entry (so Back returns to them);
      // switching between disciplines replaces it, so Back is always one step to the cards
      go(index) {
        if (index === this.active) return;
        if (index == null) {
          if (this.pushedRange && history.state?.curtisRange != null) { history.back(); return; }
          history.replaceState(null, '', location.pathname + location.search);
          this.show(null);
          return;
        }
        const hash = `#range-${this.handles[index]}`;
        if (this.active == null) {
          history.pushState({ curtisRange: index }, '', hash);
          this.pushedRange = true;
        } else {
          history.replaceState({ curtisRange: index }, '', hash);
        }
        this.show(index);
      }
      syncFromHash() {
        const index = this.indexFromHash();
        if (index == null) this.pushedRange = false;
        if (index !== this.active) this.show(index);
      }
      get stageOpen() {
        return Boolean(this.stage && !this.stage.hidden);
      }
      show(index, { instant = false } = {}) {
        if (this.stageOpen) this.finishStage();
        this.settleMorph();
        const from = this.active;
        if (index === from) return;
        if (instant || this.reduced.matches) { this.applyState(index); return; }
        this.revealAll();
        if (from == null) this.morphOpen(index);
        else if (index == null) this.morphClose(from);
        else this.switchTo(index);
      }
      // The resting layout for a state, with no motion: cards and intro, or one discipline's table and the nav
      applyState(index, { refresh = true } = {}) {
        this.cancelPanelMotion();
        this.active = index;
        const open = index != null;
        this.groupsEl.hidden = open;
        this.intro.toggleAttribute('data-off', open);
        this.nav.hidden = !open;
        this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
        this.tabs.forEach((tab, i) => tab.setAttribute('aria-current', String(i === index)));
        this.triggers.forEach((trigger, i) => trigger.setAttribute('aria-expanded', String(i === index)));
        if (open) {
          this.warm(index);
          this.pauseHover(this.panels[index].querySelector('.curtis-range__table'));
        }
        if (refresh) window.ScrollTrigger?.refresh();
      }
      // A table appears under a cursor that hasn't moved, so whatever tile happens to be beneath it would read as
      // "hovered" and dim the others (often the very bike that just arrived). Hover highlighting therefore waits
      // until the pointer genuinely moves again.
      pauseHover(table) {
        if (!table) return;
        table.dataset.hoverPaused = '';
        this.hoverResume?.abort();
        const resume = this.hoverResume = new AbortController();
        let travelled = 0;
        window.addEventListener('pointermove', event => {
          // Browsers can send synthetic, zero-distance moves when the page changes under the cursor; ignore those
          travelled += Math.abs(event.movementX || 0) + Math.abs(event.movementY || 0);
          if (travelled < 6) return;
          table.removeAttribute('data-hover-paused');
          resume.abort();
        }, { signal: resume.signal });
        this.abort?.signal.addEventListener('abort', () => resume.abort(), { once: true });
      }
      // If a new request arrives mid-morph, jump the current one to its end state before starting the next
      settleMorph() {
        this.morphVersion++;
        this.ghost?.remove();
        this.ghost = null;
        this.snapshots?.forEach(el => el.remove());
        this.snapshots = [];
        [this.intro, this.nav, ...this.triggers].forEach(el => { el.getAnimations().forEach(a => a.cancel()); el.style.visibility = ''; });
        this.querySelectorAll('[data-lifted]').forEach(el => { if (!this.stageOpen) el.removeAttribute('data-lifted'); });
        if (this.morphTarget !== undefined && this.morphTarget !== this.active) this.applyState(this.morphTarget);
        this.morphTarget = undefined;
        this.cancelPanelMotion();
      }
      lead(index) {
        return this.tilesIn(this.panels[index])[0];
      }
      // Photo cards are the photo; other tile styles land on the photo inside the tile
      landing(tile) {
        return this.photoTiles ? tile : tile.querySelector('.curtis-range__tile-image');
      }
      // Where the card's cover sits inside the lead model's full photo, mapped into a box of a given size.
      // The card shows its cover with object-fit: cover, so that is accounted for first.
      coverMapping(card, box, ratio) {
        const crop = (card.dataset.coverCrop || '').split(',').map(Number);
        if (crop.length !== 4 || crop.some(n => !Number.isFinite(n) || n < 0)) return null;
        const [cx, cy, cw, ch] = crop;
        const coverRatio = (cw * ratio) / ch;
        let width = box.width, height = box.height, ox = 0, oy = 0;
        if (box.width / box.height > coverRatio) { height = box.width / coverRatio; oy = (box.height - height) / 2; }
        else { width = box.height * coverRatio; ox = (box.width - width) / 2; }
        const imgWidth = width / cw;
        const imgHeight = imgWidth / ratio;
        return { left: ox - cx * imgWidth, top: oy - cy * imgHeight, width: imgWidth, height: imgHeight };
      }
      makeGhost(card, tile, rect, radius) {
        const ghost = document.createElement('div');
        ghost.className = 'curtis-range-ghost';
        Object.assign(ghost.style, { left: `${rect.left}px`, top: `${rect.top}px`, width: `${rect.width}px`, height: `${rect.height}px`, borderRadius: radius });
        const full = document.createElement('img');
        full.alt = '';
        const tileImg = tile.querySelector('img');
        // Prefer the exact photo the tile has already loaded: it is in memory, so it is ready on the first frame
        if (tileImg?.currentSrc) {
          full.src = tileImg.currentSrc;
        } else {
          full.sizes = '1100px';
          full.srcset = tileImg?.getAttribute('srcset') || tileImg?.dataset.srcset || '';
          full.src = tileImg?.dataset.src || '';
        }
        const coverSource = card.querySelector('.curtis-range__cover');
        const cover = document.createElement('img');
        cover.alt = '';
        cover.className = 'curtis-range-ghost__cover';
        cover.src = coverSource?.currentSrc || coverSource?.src || '';
        const shade = document.createElement('div');
        shade.className = 'curtis-range-ghost__shade';
        const band = document.createElement('div');
        band.className = 'curtis-range-ghost__band';
        const caption = card.querySelector('.curtis-range__glass')?.cloneNode(true);
        // The model's own caption travels with the photo, so the card arrives already reading as that model
        const model = document.createElement('div');
        model.className = 'curtis-range-ghost__model';
        tile.querySelectorAll('.curtis-range__tile-name, .curtis-range__tile-style, .curtis-range__tile-arrow').forEach(el => model.append(el.cloneNode(true)));
        ghost.append(full, cover, shade, band);
        if (caption) ghost.append(caption);
        if (this.photoTiles) ghost.append(model);
        document.body.append(ghost);
        this.ghost = ghost;
        return { ghost, full, cover, shade, band, caption, model };
      }
      ratioOf(index) {
        return Number(this.piecesFor(this.panels[index])[0]?.ratio) || 1.78;
      }
      // Keep the landing spot (and, when opening, the navigation above it) on screen. Any adjustment
      // happens while the section is faded, so it reads as the photo travelling rather than the page scrolling.
      keepInView(el, lead = null) {
        const minTop = (parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 72) + 24;
        const first = (lead || el).getBoundingClientRect();
        const rect = el.getBoundingClientRect();
        let delta = 0;
        if (first.top < minTop) delta = first.top - minTop;
        else if (rect.bottom > window.innerHeight) delta = Math.min(rect.bottom - window.innerHeight + 24, first.top - minTop);
        if (delta) window.scrollBy({ top: delta, behavior: 'instant' });
        return el.getBoundingClientRect();
      }
      wait(ms) { return new Promise(resolve => setTimeout(resolve, ms)); }
      // Resolves once an image has loaded and (briefly) had a chance to decode. decode() alone can stall,
      // for example in a background tab, so it never holds things up for more than a moment.
      ready(img) {
        const loaded = img.complete && img.naturalWidth && img.currentSrc
          ? Promise.resolve()
          : new Promise((resolve, reject) => {
            img.addEventListener('load', resolve, { once: true });
            img.addEventListener('error', reject, { once: true });
          });
        return loaded.then(() => Promise.race([img.decode().catch(() => {}), this.wait(250)]));
      }
      staggerIn(elements, delay, step = 110, { rise = 18, duration = 850 } = {}) {
        const settle = this.constructor.settle;
        elements.forEach((el, i) => {
          el.style.opacity = '';
          el.animate([{ opacity: 0, transform: `translateY(${rise}px)` }, { opacity: 1, transform: 'none' }],
            { duration, delay: delay + i * step, easing: settle, fill: 'backwards' });
        });
      }
      // A fixed-position copy of an element at its current place on screen, so the real layout can change
      // underneath while the copy fades away
      snapshot(el) {
        const rect = el.getBoundingClientRect();
        const copy = el.cloneNode(true);
        copy.removeAttribute('id');
        copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        copy.setAttribute('aria-hidden', 'true');
        ['data-range-trigger', 'data-range-intro', 'data-range-handle'].forEach(name => copy.removeAttribute(name));
        copy.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
        copy.classList.add('curtis-range-snapshot');
        Object.assign(copy.style, { position: 'fixed', left: `${rect.left}px`, top: `${rect.top}px`, width: `${rect.width}px`, height: `${rect.height}px`, margin: '0', visibility: 'visible', opacity: '1', transform: 'none' });
        // Stay inside the same parent where styles depend on it (the intro), but never inside something about to be hidden
        (el === this.intro ? el.parentElement : this).append(copy);
        (this.snapshots ||= []).push(copy);
        return copy;
      }
      // Where a photo of a given ratio sits when it covers a box (used when there is no cover crop to follow)
      coverFit(box, ratio) {
        const width = Math.max(box.width, box.height * ratio);
        const height = width / ratio;
        return { left: (box.width - width) / 2, top: (box.height - height) / 2, width, height };
      }
      // Card -> table. The other cards and the intro step back; the chosen card's photo pulls back from its
      // close-up to the whole bike as it settles into the first model's place; the rest of the models
      // fade in one after another beside it.
      async morphOpen(index) {
        // Phones keep the version tuned by the mobile rework; desktop gets the lighter choreography below
        if (this.phone?.matches) return this.morphOpenPhone(index);
        const version = this.morphVersion;
        this.morphTarget = index;
        const card = this.triggers[index];
        const tile = this.lead(index);
        const others = this.triggers.filter(t => t !== card);
        const ratio = this.ratioOf(index);
        const cardRect = card.getBoundingClientRect();
        const cardRadius = getComputedStyle(card).borderRadius;
        const ease = this.constructor.glide;

        // Beat one, from the very first frame: everything that is leaving dissolves as copies at its current
        // place, while the real layout switches underneath and the chosen card sets off for its new spot
        const leaving = [...others, this.intro].map(el => this.snapshot(el));
        const parts = this.makeGhost(card, tile, cardRect, cardRadius);
        this.applyState(index, { refresh: false });
        tile.dataset.lifted = '';
        const pieces = [...this.panels[index].querySelectorAll('.curtis-range__piece')].filter(piece => !piece.contains(tile));
        pieces.forEach(piece => { piece.style.opacity = '0'; });
        const landing = this.landing(tile);
        const target = this.keepInView(landing, this.nav);
        const radius = getComputedStyle(landing).borderRadius;

        leaving.forEach(el => el.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'scale(.985)' }], { duration: 260, easing: 'ease-out', fill: 'forwards' }));

        // The travelling card sits at its destination and is moved there by transform; only its own (isolated)
        // size changes during the flight
        Object.assign(parts.ghost.style, { left: `${target.left}px`, top: `${target.top}px`, width: `${target.width}px`, height: `${target.height}px`, borderRadius: radius });
        const flight = parts.ghost.animate([
          { transform: `translate(${cardRect.left - target.left}px, ${cardRect.top - target.top}px)`, width: `${cardRect.width}px`, height: `${cardRect.height}px`, borderRadius: cardRadius },
          { transform: 'none', width: `${target.width}px`, height: `${target.height}px`, borderRadius: radius }
        ], { duration: 780, easing: ease, fill: 'forwards' });

        // The photo pulls back from the close-up to the whole bike by scale alone, and leads the card's change
        // of shape very slightly so the two read as one motion
        const endHeight = this.photoTiles ? target.width / ratio : target.height;
        const frameHeight = tile.querySelector('.curtis-range__tile-image').getBoundingClientRect().height;
        const endTop = this.photoTiles ? Math.max(0, (frameHeight - endHeight) / 2) : 0;
        const from = this.coverMapping(card, cardRect, ratio) || this.coverFit(cardRect, ratio);
        Object.assign(parts.full.style, { inset: 'auto', left: '0px', top: `${endTop}px`, width: `${target.width}px`, height: `${endHeight}px`, objectFit: 'cover', transformOrigin: '0 0' });
        parts.full.animate([
          { transform: `translate(${from.left}px, ${from.top - endTop}px) scale(${from.width / target.width})` },
          { transform: 'none' }
        ], { duration: 700, easing: ease, fill: 'forwards' });
        // The close-up hands over to the full photo straight away (they match), or crossfades if they don't
        const matched = Boolean(card.dataset.coverCrop);
        const handOver = () => parts.cover.animate([{ opacity: 1 }, { opacity: 0 }], { duration: matched ? 140 : 420, easing: 'ease-out', fill: 'forwards' });
        if (parts.full.complete && parts.full.naturalWidth) handOver();
        else Promise.race([this.ready(parts.full).catch(() => {}), this.wait(350)]).then(() => { if (version === this.morphVersion) handOver(); });

        parts.caption?.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 180, easing: 'ease-out', fill: 'forwards' });
        if (this.photoTiles) [parts.shade, parts.band].forEach(el => el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 420, delay: 80, easing: 'ease-out', fill: 'forwards' }));
        else [parts.shade, parts.band].forEach(el => el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 220, easing: 'ease-out', fill: 'forwards' }));
        parts.model.style.opacity = '0';
        parts.model.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 320, delay: 380, easing: 'ease-out', fill: 'forwards' });
        // The model card's own soft fade (photo into its text area) and hairline border travel with the photo and
        // grow in during the journey, so nothing appears in a single frame when the real card takes over
        if (this.photoTiles) {
          const fade = document.createElement('div');
          fade.className = 'curtis-range-ghost__tile-fade';
          fade.style.height = `${frameHeight}px`;
          parts.ghost.insertBefore(fade, parts.model);
          fade.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 480, delay: 160, easing: 'ease-in-out', fill: 'both' });
          parts.ghost.style.boxShadow = getComputedStyle(tile).boxShadow;
          parts.ghost.style.outline = `1px solid ${getComputedStyle(tile).borderTopColor}`;
          parts.ghost.style.outlineOffset = '-1px';
        }

        // Beat two: the heading and the rest of the discipline drift in, close together, as the card settles
        this.nav.animate([{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }], { duration: 520, delay: 160, easing: ease, fill: 'backwards' });
        this.staggerIn(pieces, 220, 60, { rise: 8, duration: 600 });

        await flight.finished.catch(() => {});
        if (version !== this.morphVersion) return;
        tile.removeAttribute('data-lifted');
        parts.ghost.remove();
        this.ghost = null;
        leaving.forEach(el => el.remove());
        this.snapshots = [];
        this.morphTarget = undefined;
        this.tabs[index]?.focus({ preventScroll: true });
        window.ScrollTrigger?.refresh();
      }
      async morphOpenPhone(index) {
        const version = this.morphVersion;
        this.morphTarget = index;
        const card = this.triggers[index];
        const tile = this.lead(index);
        const others = this.triggers.filter(t => t !== card);
        const ratio = this.ratioOf(index);
        this.warm(index);
        const cardRect = card.getBoundingClientRect();
        const parts = this.makeGhost(card, tile, cardRect, getComputedStyle(card).borderRadius);
        const start = this.coverMapping(card, cardRect, ratio);
        if (start) Object.assign(parts.full.style, { left: `${start.left}px`, top: `${start.top}px`, width: `${start.width}px`, height: `${start.height}px` });
        else Object.assign(parts.full.style, { inset: '0', width: '100%', height: '100%', objectFit: 'cover' });
        card.style.visibility = 'hidden';

        const out = { duration: 240, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' };
        others.forEach(el => el.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'scale(.97)' }], out));
        this.intro.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-8px)' }], out);
        parts.caption?.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 260, easing: 'ease-out', fill: 'forwards' });
        parts.model.style.opacity = '0';
        if (!this.photoTiles) [parts.shade, parts.band].forEach(el => el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 300, easing: 'ease-out', fill: 'forwards' }));
        await Promise.all([this.wait(240), Promise.race([this.load(tile), this.wait(500)])]);
        if (version !== this.morphVersion) return;

        this.applyState(index);
        others.forEach(el => el.getAnimations().forEach(a => a.cancel()));
        this.intro.getAnimations().forEach(a => a.cancel());
        card.style.visibility = '';
        tile.dataset.lifted = '';
        const pieces = [...this.panels[index].querySelectorAll('.curtis-range__piece')].filter(piece => !piece.contains(tile));
        pieces.forEach(piece => { piece.style.opacity = '0'; });
        const landing = this.landing(tile);
        const target = this.keepInView(landing, this.nav);
        const radius = getComputedStyle(landing).borderRadius;

        const lift = { duration: 1050, easing: this.constructor.lift, fill: 'forwards' };
        const flight = parts.ghost.animate([
          { left: `${cardRect.left}px`, top: `${cardRect.top}px`, width: `${cardRect.width}px`, height: `${cardRect.height}px`, borderRadius: getComputedStyle(card).borderRadius },
          { left: `${target.left}px`, top: `${target.top}px`, width: `${target.width}px`, height: `${target.height}px`, borderRadius: radius }
        ], lift);
        // On photo cards the photo sits at the top with room for the text beneath it
        const endHeight = this.photoTiles ? target.width / ratio : target.height;
        const frameHeight = tile.querySelector('.curtis-range__tile-image').getBoundingClientRect().height;
        const endTop = this.photoTiles ? Math.max(0, (frameHeight - endHeight) / 2) : 0;
        if (start) {
          parts.full.animate([
            { left: `${start.left}px`, top: `${start.top}px`, width: `${start.width}px`, height: `${start.height}px` },
            { left: '0px', top: `${endTop}px`, width: `${target.width}px`, height: `${endHeight}px` }
          ], lift);
          parts.cover.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 500, easing: 'ease-in', fill: 'forwards' });
        } else {
          if (this.photoTiles) {
            Object.assign(parts.full.style, { inset: 'auto', left: '0px', top: '0px' });
            parts.full.animate([
              { top: '0px', width: `${cardRect.width}px`, height: `${cardRect.height}px`, objectFit: 'cover' },
              { top: `${endTop}px`, width: `${target.width}px`, height: `${endHeight}px`, objectFit: 'cover' }
            ], lift);
          }
          parts.cover.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 800, delay: 150, easing: 'ease-in-out', fill: 'forwards' });
        }
        // The discipline card's shade gives way to the model card's lighter one
        if (this.photoTiles) [parts.shade, parts.band].forEach(el => el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 600, delay: 200, easing: 'ease-in-out', fill: 'forwards' }));
        parts.model.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 450, delay: 520, easing: 'ease-out', fill: 'forwards' });
        this.nav.animate([{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }], { duration: 800, delay: 120, easing: this.constructor.settle, fill: 'backwards' });
        // The rest of the discipline arrives while the card is still travelling
        this.staggerIn(pieces, 60, 90);

        await flight.finished.catch(() => {});
        if (version !== this.morphVersion) return;
        tile.removeAttribute('data-lifted');
        parts.ghost.remove();
        this.ghost = null;
        this.morphTarget = undefined;
        this.tabs[index]?.focus({ preventScroll: true });
      }
      // Table -> cards: no journey back, just a quiet exchange. The models and navigation fade out,
      // then the intro and the discipline cards fade back in where they were.
      async morphClose(from) {
        const version = this.morphVersion;
        this.morphTarget = null;
        const card = this.triggers[from];
        const pieces = [...this.panels[from].querySelectorAll('.curtis-range__piece')];
        const out = { duration: 260, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' };
        pieces.slice().reverse().forEach((piece, i) => piece.animate([{ opacity: 1 }, { opacity: 0 }], { ...out, delay: i * 25 }));
        this.nav.animate([{ opacity: 1 }, { opacity: 0 }], out);
        await this.wait(260 + Math.min(pieces.length, 6) * 25);
        if (version !== this.morphVersion) return;

        this.applyState(null);
        this.keepInView(this.groupsEl);
        const fade = { duration: 700, easing: 'ease-out', fill: 'backwards' };
        this.intro.animate([{ opacity: 0 }, { opacity: 1 }], fade);
        this.triggers.forEach((trigger, i) => trigger.animate([{ opacity: 0 }, { opacity: 1 }], { ...fade, delay: 60 + i * 80 }));
        this.morphTarget = undefined;
        card.focus({ preventScroll: true });
      }
      // Discipline -> discipline from the heading: the table clears and the next one is laid out in turn
      async switchTo(index) {
        const version = this.morphVersion;
        this.morphTarget = index;
        const pieces = [...this.panels[this.active].querySelectorAll('.curtis-range__piece')];
        this.tabs.forEach((tab, i) => tab.setAttribute('aria-current', String(i === index)));
        this.warm(index);
        pieces.forEach((piece, i) => piece.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-10px)' }], { duration: 280, delay: i * 35, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' }));
        await Promise.all([this.wait(280 + Math.min(pieces.length, 6) * 35), Promise.race([this.load(this.lead(index)), this.wait(600)])]);
        if (version !== this.morphVersion) return;
        this.applyState(index);
        this.staggerIn([...this.panels[index].querySelectorAll('.curtis-range__piece')], 0);
        this.morphTarget = undefined;
      }
      close() {
        this.go(null);
      }

      /* ---------- The focused view ---------- */

      setupStage(options) {
        const stage = this.stage = this.querySelector('[data-stage]');
        if (!stage) return;
        const part = name => stage.querySelector(`[data-stage-${name}]`);
        this.parts = {
          veil: stage.querySelector('.curtis-range__stage-veil'),
          bar: stage.querySelector('.curtis-range__stage-bar'),
          strip: stage.querySelector('.curtis-range__stage-strip'),
          figure: part('figure'), low: part('low'), high: part('high'), info: part('info'),
          discipline: part('discipline'), style: part('style'), title: part('title'), tagline: part('tagline'),
          price: part('price'), finishesWrap: part('finishes-wrap'), finishes: part('finishes'),
          finishName: part('finish-name'), configure: part('configure'), configureLabel: part('configure-label'),
          thumbs: part('thumbs'), steps: [...stage.querySelectorAll('[data-stage-step]')],
          position: part('position')
        };

        this.addEventListener('click', event => {
          const tile = event.target.closest('[data-piece]');
          // Let modified clicks open the product page as a normal link
          if (!tile || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.openStage(tile);
        }, options);
        // Intent again: hovering a tile starts its large photo, so the focused view opens sharp
        this.addEventListener('pointerover', event => {
          const tile = event.target.closest?.('[data-piece]');
          if (tile && !this.stageOpen) this.preloadStage(tile);
        }, options);
        this.addEventListener('focusin', event => {
          const tile = event.target.closest('[data-piece]');
          if (tile && !this.stageOpen) this.preloadStage(tile);
        }, options);

        stage.querySelector('[data-stage-close]').addEventListener('click', () => this.closeStage(), options);
        this.parts.steps.forEach(button => button.addEventListener('click', () => this.step(Number(button.dataset.stageStep)), options));
        this.parts.thumbs.addEventListener('click', event => {
          const thumb = event.target.closest('[data-thumb]');
          if (thumb) this.showPiece(Number(thumb.dataset.thumb));
        }, options);
        this.parts.finishes.addEventListener('click', event => {
          const swatch = event.target.closest('[data-finish]');
          if (swatch) this.chooseFinish(swatch.dataset.finish);
        }, options);
        ['pointerover', 'focusin'].forEach(type => this.parts.finishes.addEventListener(type, event => {
          const swatch = event.target.closest?.('[data-finish]');
          if (swatch) this.preloadFinish(swatch.dataset.finish);
        }, options));
        this.parts.finishes.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
          event.preventDefault();
          event.stopPropagation();
          const swatches = [...this.parts.finishes.querySelectorAll('[data-finish]')];
          const current = Math.max(0, swatches.indexOf(document.activeElement));
          const next = swatches[(current + (/Right|Down/.test(event.key) ? 1 : -1) + swatches.length) % swatches.length];
          next.focus();
          this.chooseFinish(next.dataset.finish);
        }, options);
        stage.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight') this.step(1);
          if (event.key === 'ArrowLeft') this.step(-1);
        }, options);
        // Esc: play the closing transition instead of vanishing

        // If the browser closes the dialog regardless (a repeated Esc), tidy up without animation



        // Swipe between models on touch screens
        let swipeX = null;
        this.parts.figure.addEventListener('pointerdown', event => { swipeX = event.clientX; }, options);
        this.parts.figure.addEventListener('pointerup', event => {
          if (swipeX == null) return;
          const delta = event.clientX - swipeX;
          swipeX = null;
          if (Math.abs(delta) > 50) this.step(delta < 0 ? 1 : -1);
        }, options);
      }
      piecesFor(panel) {
        this.pieceData ||= new WeakMap();
        if (!this.pieceData.has(panel)) {
          let pieces = [];
          try { pieces = JSON.parse(panel.querySelector('[data-pieces]')?.textContent || '[]'); } catch (error) {}
          this.pieceData.set(panel, pieces);
        }
        return this.pieceData.get(panel);
      }
      stageSizes(piece) {
        return `(min-width: 900px) min(62vw, 1600px, calc((100vh - 300px) * ${piece.ratio})), 92vw`;
      }
      preloadStage(tile) {
        const panel = tile.closest('.curtis-range__panel');
        const piece = this.piecesFor(panel)[this.tilesIn(panel).indexOf(tile)];
        if (!piece || !piece.srcset) return;
        this.preloaded ||= new Set();
        if (this.preloaded.has(piece.srcset)) return;
        this.preloaded.add(piece.srcset);
        const img = new Image();
        img.sizes = this.stageSizes(piece);
        img.srcset = piece.srcset;
      }
      label(name, values = {}) {
        let text = this.stage.dataset[`label${name}`] || '';
        Object.entries(values).forEach(([key, value]) => { text = text.replace(`[${key}]`, value); });
        return text;
      }
      // Fill the focused view with one model. The table photo shows at once (already decoded), and the
      // large photo dissolves in over it when ready.
      fillStage(index) {
        const view = this.view;
        view.index = index;
        view.finish = null;
        const piece = view.pieces[index];
        const tile = view.tiles[index];
        const p = this.parts;
        view.tiles.forEach(t => t.removeAttribute('data-lifted'));
        tile.dataset.lifted = '';
        p.figure.style.setProperty('--stage-ratio', piece.ratio);
        p.discipline.textContent = this.label('Models', { title: view.panel.dataset.discipline || '' });
        p.style.textContent = piece.style;
        p.title.textContent = piece.title;
        p.tagline.textContent = piece.tagline || '';
        p.price.textContent = piece.price ? this.label('From', { price: piece.price }) : '';
        p.low.src = tile.querySelector('img')?.currentSrc || '';
        p.figure.querySelectorAll('.curtis-range__stage-high').forEach(img => { if (img !== p.high) img.remove(); });
        p.high.alt = piece.title;
        p.figure.removeAttribute('data-sharp');
        p.high.removeAttribute('srcset');
        p.high.removeAttribute('src');
        delete p.high.dataset.srcset;
        const token = view.token = (view.token || 0) + 1;
        if (piece.srcset) {
          p.high.sizes = this.stageSizes(piece);
          p.high.srcset = piece.srcset;
          p.high.dataset.srcset = piece.srcset;
          this.ready(p.high).then(() => { if (this.view?.token === token) p.figure.dataset.sharp = ''; }).catch(() => {});
        }
        p.finishes.innerHTML = '';
        (piece.finishes || []).forEach(finish => {
          const swatch = document.createElement('button');
          swatch.type = 'button';
          swatch.className = 'curtis-range__swatch';
          swatch.setAttribute('role', 'radio');
          swatch.setAttribute('aria-checked', 'false');
          swatch.tabIndex = -1;
          swatch.dataset.finish = finish.slug;
          if (finish.premium) swatch.dataset.premium = '';
          swatch.style.setProperty('--swatch', finish.hex);
          swatch.setAttribute('aria-label', finish.premium ? `${finish.name}, ${this.label('Premium')}` : finish.name);
          swatch.title = finish.name;
          p.finishes.append(swatch);
        });
        const first = p.finishes.querySelector('[data-finish]');
        if (first) first.tabIndex = 0;
        p.finishesWrap.hidden = !piece.finishes?.length;
        p.finishName.textContent = this.label('Choose');
        p.configure.href = piece.url;
        p.configureLabel.textContent = this.label('Configure');
        p.thumbs.querySelectorAll('[data-thumb]').forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index)));
        if (p.position) p.position.textContent = `${index + 1} / ${view.tiles.length}`;
        const currentThumb = p.thumbs.querySelector('[aria-current=true]');
        if (this.phone.matches) {
          // Phones: the switcher sits above the photo, so only slide the chips sideways and never move the page
          if (currentThumb) p.thumbs.scrollTo({ left: currentThumb.offsetLeft - (p.thumbs.clientWidth - currentThumb.offsetWidth) / 2, behavior: 'instant' });
        } else {
          currentThumb?.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'instant' });
        }
      }
      // A chosen finish travels with the visitor: the product page pre-selects it in the configurator
      chooseFinish(slug) {
        const piece = this.view.pieces[this.view.index];
        const finish = piece.finishes.find(f => f.slug === slug);
        if (!finish) return;
        this.view.finish = slug;
        this.parts.finishes.querySelectorAll('[data-finish]').forEach(swatch => {
          const chosen = swatch.dataset.finish === slug;
          swatch.setAttribute('aria-checked', String(chosen));
          swatch.tabIndex = chosen ? 0 : -1;
        });
        this.parts.finishName.textContent = finish.premium ? `${finish.name} · ${this.label('Premium')}` : finish.name;
        const url = new URL(piece.url, location.origin);
        url.searchParams.set('finish', slug);
        this.parts.configure.href = url.pathname + url.search;
        this.parts.configureLabel.textContent = this.label('ConfigureIn', { finish: finish.name });
        this.showFinishPhoto(piece, finish.srcset);
      }
      // Repaint the bike in the chosen finish: the current photo is held underneath while the new one
      // decodes, then the new finish dissolves in over it, so the frame never flashes empty
      showFinishPhoto(piece, srcset) {
        const p = this.parts;
        if (!srcset || p.high.dataset.srcset === srcset) return;
        const token = this.view.token = (this.view.token || 0) + 1;
        // A fresh image is decoded off-screen, then laid over the current photo and faded in. Swapping the
        // srcset on the visible image instead can report the old photo as ready, which left the view one
        // finish behind.
        const next = new Image();
        next.className = 'curtis-range__stage-high';
        next.alt = p.high.alt;
        next.sizes = this.stageSizes(piece);
        next.srcset = srcset;
        next.dataset.srcset = srcset;
        this.ready(next).then(() => {
          if (this.view?.token !== token) return;
          const previous = p.high;
          next.style.opacity = '0';
          p.figure.append(next);
          p.high = next;
          p.figure.dataset.sharp = '';
          next.offsetWidth;
          next.style.opacity = '';
          setTimeout(() => { if (previous !== p.high) previous.remove(); }, 800);
        }).catch(() => {});
      }
      preloadFinish(slug) {
        const piece = this.view?.pieces[this.view.index];
        const finish = piece?.finishes.find(f => f.slug === slug);
        if (!finish?.srcset) return;
        this.preloaded ||= new Set();
        if (this.preloaded.has(finish.srcset)) return;
        this.preloaded.add(finish.srcset);
        const img = new Image();
        img.sizes = this.stageSizes(piece);
        img.srcset = finish.srcset;
      }
      buildThumbs() {
        const view = this.view;
        this.parts.thumbs.innerHTML = '';
        view.tiles.forEach((tile, i) => {
          const thumb = document.createElement('button');
          thumb.type = 'button';
          thumb.className = 'curtis-range__stage-thumb';
          thumb.dataset.thumb = i;
          const img = document.createElement('img');
          img.alt = '';
          img.src = tile.querySelector('img')?.currentSrc || tile.querySelector('img')?.dataset.src || '';
          const name = document.createElement('span');
          name.textContent = view.pieces[i]?.title || '';
          thumb.append(img, name);
          this.parts.thumbs.append(thumb);
        });
        const single = view.tiles.length < 2;
        this.parts.strip.hidden = single;
      }
      lockScroll() {
        const gap = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.overflow = 'hidden';
        if (gap > 0) document.body.style.paddingRight = `${gap}px`;
      }
      unlockScroll() {
        document.documentElement.style.overflow = '';
        document.body.style.paddingRight = '';
      }
      // The transform that places the figure exactly over a tile's photo (same photo, same ratio)
      flip(from, to) {
        const scale = from.width / to.width;
        return { transform: `translate(${from.left - to.left}px, ${from.top - to.top}px) scale(${scale})`, borderRadius: `${18 / scale}px` };
      }
      chrome() {
        const p = this.parts;
        return [p.bar, ...p.info.children, p.strip].filter(el => el && !el.hidden);
      }
      openStage(tile) {
        if (this.stageOpen || this.closing) return;
        const panel = tile.closest('.curtis-range__panel');
        const tiles = this.tilesIn(panel);
        this.view = { panel, tiles, pieces: this.piecesFor(panel) };
        const index = tiles.indexOf(tile);
        if (!this.view.pieces[index]) return;
        const p = this.parts;
        this.load(tile);
        this.buildThumbs();
        this.fillStage(index);
        const frame = tile.querySelector('.curtis-range__tile-image').getBoundingClientRect();
        const ratio = Number(this.view.pieces[index].ratio) || frame.width / frame.height;
        const photoHeight = Math.min(frame.height, frame.width / ratio);
        const from = { left: frame.left, width: frame.width, top: frame.top + (frame.height - photoHeight) / 2, height: photoHeight };
        // In the page: the table steps aside and the model takes its place
        panel.hidden = true;
        this.stage.hidden = false;
        this.keepInView(p.figure, this.nav);
        if (this.backLabel) this.backLabel.textContent = this.label('Models', { title: panel.dataset.discipline || '' });
        p.title.focus({ preventScroll: true });
        window.ScrollTrigger?.refresh();
        if (this.reduced.matches) return;

        const to = p.figure.getBoundingClientRect();
        p.figure.animate([{ ...this.flip(from, to) }, { transform: 'none', borderRadius: '24px' }], { duration: 1000, easing: this.constructor.lift });
        this.chrome().forEach((el, i) => el.animate(
          [{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'none' }],
          { duration: 850, delay: 380 + i * 60, easing: this.constructor.settle, fill: 'backwards' }
        ));
      }
      // Moving between models: the current one slips away to one side, the next arrives from the other
      step(delta) {
        if (!this.view || !this.stageOpen) return;
        const count = this.view.tiles.length;
        if (count < 2) return;
        this.showPiece((this.view.index + delta + count) % count, delta);
      }
      showPiece(index, direction) {
        const view = this.view;
        if (!view || index === view.index || this.swapping || this.closing) return;
        const dir = Math.sign(direction ?? (index - view.index)) || 1;
        const p = this.parts;
        this.load(view.tiles[index]);
        if (this.reduced.matches) { this.fillStage(index); return; }
        this.swapping = true;
        const out = { duration: 320, easing: 'cubic-bezier(.4,0,1,1)', fill: 'forwards' };
        const figureOut = p.figure.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: `translateX(${-28 * dir}px)` }], out);
        p.info.animate([{ opacity: 1 }, { opacity: 0 }], { ...out, duration: 240 });
        figureOut.finished.then(() => {
          this.fillStage(index);
          p.figure.getAnimations().forEach(a => a.cancel());
          p.info.getAnimations().forEach(a => a.cancel());
          p.figure.animate([{ opacity: 0, transform: `translateX(${36 * dir}px)` }, { opacity: 1, transform: 'none' }], { duration: 800, easing: this.constructor.settle });
          [...p.info.children].filter(el => !el.hidden).forEach((el, i) => el.animate(
            [{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }],
            { duration: 700, delay: 120 + i * 50, easing: this.constructor.settle, fill: 'backwards' }
          ));
        }).catch(() => {}).finally(() => { this.swapping = false; });
      }
      // Closing: a quiet fade back to the models, the one just viewed returning first
      closeStage() {
        if (!this.stageOpen || this.closing) return;
        this.closing = true;
        if (this.reduced.matches) { this.finishStage({ fadeIn: true }); return; }
        this.stage.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 260, easing: 'ease-in', fill: 'forwards' })
          .finished.then(() => this.finishStage({ fadeIn: true })).catch(() => this.finishStage({ fadeIn: true }));
      }
      finishStage({ fadeIn = false } = {}) {
        const view = this.view;
        this.stage.getAnimations({ subtree: true }).forEach(a => a.cancel());
        this.stage.hidden = true;
        if (this.backLabel) this.backLabel.textContent = this.backLabel.dataset.all;
        view?.tiles.forEach(t => t.removeAttribute('data-lifted'));
        if (view && this.panels.indexOf(view.panel) === this.active) {
          view.panel.hidden = false;
          this.pauseHover(view.panel.querySelector('.curtis-range__table'));
          const tile = view.tiles[view.index];
          if (fadeIn) {
            this.keepInView(tile);
            if (!this.reduced.matches) this.staggerIn([...view.panel.querySelectorAll('.curtis-range__piece')], 0, 50);
          }
          tile?.focus({ preventScroll: true });
        }
        this.view = null;
        this.closing = false;
        this.swapping = false;
        window.ScrollTrigger?.refresh();
      }
      disconnectedCallback() {
        if (this.stageOpen) this.finishStage();
        this.abort?.abort();
        this.approach?.disconnect();
        this.cardWatcher?.disconnect();
        cancelAnimationFrame(this.entranceFrame);
        this.stopEntrance();
        this.cancelPanelMotion();
        this.active = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curtis-workshop-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('curtis-workshop-showcase')) {
    // Videos play only while their tile is mostly on screen, and never with reduced motion
    customElements.define(
      'curtis-workshop-showcase',
      class CurtisWorkshopShowcase extends HTMLElement {
        connectedCallback() {
          this.setupPhoneRow();
          const videos = [...this.querySelectorAll('[data-showcase-video]')];
          if (!videos.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          this.observer = new IntersectionObserver(
            (entries) => {
              for (const { target, isIntersecting } of entries) {
                const tile = target.closest('.workshop-showcase__tile');
                if (isIntersecting) {
                  target.play().then(() => tile.classList.add('is-playing')).catch(() => {});
                } else {
                  target.pause();
                  tile.classList.remove('is-playing');
                }
              }
            },
            { threshold: 0.6 },
          );
          videos.forEach((video) => this.observer.observe(video));
        }

        // Phones: the tiles are a swipe row. The tile snapped into place is the one being looked at, so it
        // gets the colour that hover gives on desktop; dots, count and arrows say where you are.
        setupPhoneRow() {
          const phone = window.matchMedia('(max-width: 749px)');
          const tiles = [...this.querySelectorAll('.workshop-showcase__tile')];
          const nav = this.closest('.workshop-showcase')?.querySelector('[data-showcase-nav]');
          if (tiles.length < 1) return;
          const dots = nav ? [...nav.querySelectorAll('[data-showcase-dot]')] : [];
          const count = nav?.querySelector('[data-showcase-count]');
          const [prev, next] = nav ? [...nav.querySelectorAll('[data-showcase-step]')] : [];
          const current = () => {
            let best = 0;
            tiles.forEach((tile, i) => {
              if (Math.abs(tile.offsetLeft - tiles[0].offsetLeft - this.scrollLeft) < Math.abs(tiles[best].offsetLeft - tiles[0].offsetLeft - this.scrollLeft)) best = i;
            });
            return best;
          };
          let frame = 0;
          const sync = () => {
            frame = 0;
            const index = current();
            tiles.forEach((tile, i) => tile.classList.toggle('is-centred', phone.matches && i === index));
            dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
            if (count) count.textContent = `${index + 1} / ${tiles.length}`;
            if (prev) prev.disabled = index === 0;
            if (next) next.disabled = index === tiles.length - 1;
          };
          this.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(sync); }, { passive: true });
          phone.addEventListener('change', sync);
          nav?.addEventListener('click', (event) => {
            const button = event.target.closest('[data-showcase-step]');
            if (!button) return;
            const target = tiles[Math.min(tiles.length - 1, Math.max(0, current() + Number(button.dataset.showcaseStep)))];
            const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            this.scrollTo({ left: target.offsetLeft - tiles[0].offsetLeft, behavior: still ? 'instant' : 'smooth' });
          });
          sync();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-jersey"] && !Shopify.designMode) return;
  try {
    
  class JerseyProduct extends HTMLElement {
    #variants = [];
    #galleryObserver = null;

    connectedCallback() {
      const variantData = this.querySelector('[data-variant-data]');
      if (!variantData) return;

      try {
        this.#variants = JSON.parse(variantData.textContent);
      } catch (error) {
        console.error('Unable to load jersey variants', error);
        return;
      }

      this.addEventListener('change', this.#handleOptionChange);
      this.addEventListener('click', this.#handleGalleryClick);
      this.#observeGallery();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.#handleOptionChange);
      this.removeEventListener('click', this.#handleGalleryClick);
      this.#galleryObserver?.disconnect();
    }

    #handleOptionChange = (event) => {
      if (!event.target.matches('[data-option-input]')) return;

      const selectedOptions = Array.from(this.querySelectorAll('[data-option-position]')).map((fieldset) => {
        const selected = fieldset.querySelector('[data-option-input]:checked');
        const selectedLabel = fieldset.querySelector('[data-selected-option]');
        if (selectedLabel && selected) selectedLabel.textContent = selected.value;
        return selected?.value;
      });

      const variant = this.#variants.find((item) =>
        item.options.every((option, index) => option === selectedOptions[index])
      );

      this.#updateVariant(variant);
    };

    #updateVariant(variant) {
      const variantId = this.querySelector('[data-variant-id]');
      const price = this.querySelector('[data-price]');
      const comparePrice = this.querySelector('[data-compare-price]');
      const status = this.querySelector('[data-variant-status]');
      const button = this.querySelector('[ref="addToCartButton"]');
      const buttonText = button?.querySelector('.add-to-cart-text__content span span');
      const quantity = this.querySelector('.jersey-quantity__input');
      const availableText = this.dataset.availableText || 'Available';
      const addToCartText = this.dataset.addToCartText || 'Add to cart';
      const soldOutText = this.dataset.soldOutText || 'Sold out';
      const unavailableText = this.dataset.unavailableText || 'Unavailable';

      if (!variant) {
        if (variantId) variantId.value = '';
        if (status) status.textContent = unavailableText;
        if (button) button.disabled = true;
        if (buttonText) buttonText.textContent = unavailableText;
        return;
      }

      if (variantId) variantId.value = variant.id;
      if (price) price.textContent = variant.price;
      if (comparePrice) {
        comparePrice.textContent = variant.comparePrice || '';
        comparePrice.classList.toggle('jersey-product__compare-price--hidden', !variant.comparePrice);
      }
      if (status) status.textContent = variant.available ? availableText : soldOutText;
      if (button) button.disabled = !variant.available;
      if (buttonText) buttonText.textContent = variant.available ? addToCartText : soldOutText;

      if (quantity) {
        quantity.min = variant.quantityMin || 1;
        quantity.step = variant.quantityStep || 1;
        if (variant.quantityMax) quantity.max = variant.quantityMax;
        else quantity.removeAttribute('max');
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      if (variant.featuredMediaId) this.#showMedia(variant.featuredMediaId);
    }

    #handleGalleryClick = (event) => {
      const dot = event.target.closest('[data-gallery-dot]');
      if (!dot) return;

      const items = this.querySelectorAll('[data-gallery-item]');
      const target = items[Number(dot.dataset.galleryDot)];
      target?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    };

    #showMedia(mediaId) {
      const target = this.querySelector(`[data-media-id="${mediaId}"]`);
      if (!target || window.matchMedia('(min-width: 990px)').matches) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }

    #observeGallery() {
      const gallery = this.querySelector('[data-gallery]');
      const items = this.querySelectorAll('[data-gallery-item]');
      if (!gallery || items.length < 2 || !('IntersectionObserver' in window)) return;

      this.#galleryObserver = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            const index = Array.from(items).indexOf(entry.target);
            for (const dot of this.querySelectorAll('[data-gallery-dot]')) {
              const isActive = Number(dot.dataset.galleryDot) === index;
              dot.classList.toggle('jersey-gallery-nav__button--active', isActive);
              dot.setAttribute('aria-current', isActive ? 'true' : 'false');
            }
          }
        },
        { root: gallery, threshold: 0.6 }
      );

      for (const item of items) this.#galleryObserver.observe(item);
    }
  }

  if (!customElements.get('jersey-product')) {
    customElements.define('jersey-product', JerseyProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-models"] && !Shopify.designMode) return;
  try {
    
  class MegaMenuModels {
    constructor() {
      this.wrapper = document.querySelector('.page-models-wrapper');
      if (!this.wrapper) return;
      
      this.modelTriggers = this.wrapper.querySelectorAll('[data-model-trigger]');
      
      this.focusTitle = this.wrapper.querySelector('#MegaMenuModels-FocusTitle');
      this.focusDesc = this.wrapper.querySelector('#MegaMenuModels-FocusDesc');
      this.focusUrl = this.wrapper.querySelector('#MegaMenuModels-FocusUrl');
      this.focusImage = this.wrapper.querySelector('#MegaMenuModels-FocusImage');
      this.focusContent = this.wrapper.querySelector('#MegaMenuModels-FocusContent');

      this.init();
    }

    init() {
      // Hover on models list
      this.modelTriggers.forEach(trigger => {
        trigger.addEventListener('pointerenter', (e) => this.handleModelHover(e.currentTarget));
        // Fallback for keyboard
        trigger.addEventListener('focus', (e) => this.handleModelHover(e.currentTarget));
      });
    }

    handleModelHover(triggerElement) {
      // Update active class
      this.modelTriggers.forEach(el => el.classList.remove('is-active'));
      triggerElement.classList.add('is-active');

      const parentLi = triggerElement.closest('li');
      if (!parentLi) return;

      const title = parentLi.dataset.modelTitle;
      const desc = parentLi.dataset.modelDesc;
      const url = parentLi.dataset.modelUrl;
      const imageUrl = parentLi.dataset.modelImage;

      this.updateFocusPanel(title, desc, url, imageUrl);
    }

    updateFocusPanel(title, desc, url, imageUrl) {
      this.focusContent.classList.add('is-transitioning');
      
      // Small timeout to allow transition to start
      setTimeout(() => {
        if (this.focusTitle) this.focusTitle.textContent = title;
        if (this.focusDesc) this.focusDesc.textContent = desc;
        if (this.focusUrl) this.focusUrl.href = url;
        
        if (this.focusImage && imageUrl) {
          this.focusImage.src = imageUrl;
          // Only remove transition class when image is loaded
          this.focusImage.onload = () => {
             this.focusContent.classList.remove('is-transitioning');
          };
        } else {
           this.focusContent.classList.remove('is-transitioning');
        }
      }, 150);
    }
  }

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    new MegaMenuModels();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["statement-reveal"] && !Shopify.designMode) return;
  try {
    
  class CurtisStatement extends HTMLElement {
    constructor() {
      super();
      this.phrases = this.querySelectorAll('.curtis-statement__phrase');
      this.punchline = this.querySelector('.curtis-statement__punchline');
      this.cta = this.querySelector('.curtis-statement__cta-wrapper');
      
      this.initAnimation();
    }

    initAnimation() {
      if (typeof window.gsap === 'undefined' || typeof window.ScrollTrigger === 'undefined') {
        return;
      }

      const tl = window.gsap.timeline({
        scrollTrigger: {
          trigger: this,
          start: 'top 60%', 
          toggleActions: 'play none none none' 
        }
      });

      if (this.punchline) {
        tl.to(this.punchline, {
          autoAlpha: 1,
          y: 0,
          duration: 1.2,
          ease: "back.out(1.5)" 
        }, 0.2);
      }
      
      if (this.cta) {
        tl.to(this.cta, {
          autoAlpha: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.out"
        }, 0.8);
      }

      if (this.phrases.length > 0) {
        this.phrases.forEach((phrase, index) => {
          window.gsap.set(phrase, { yPercent: 100, autoAlpha: 0 });
          
          const startTime = index * 2.5; 
          
          tl.to(phrase, {
            yPercent: -50, 
            autoAlpha: 1,
            duration: 0.8,
            ease: "power3.out"
          }, startTime);
          
          if (index < this.phrases.length - 1) {
            tl.to(phrase, {
              yPercent: -200, 
              autoAlpha: 0,
              duration: 0.6,
              ease: "power3.in"
            }, startTime + 1.8);
          }
        });
      }
    }

    disconnectedCallback() {
      if (window.ScrollTrigger) {
        window.ScrollTrigger.getAll().forEach(st => {
          if (st.trigger === this) st.kill();
        });
      }
    }
  }

  if (!customElements.get('statement-reveal')) {
    customElements.define('statement-reveal', CurtisStatement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["workshop-build-contents"] && !Shopify.designMode) return;
  try {
    
  const initWorkshopProgress = (progress) => {
    const label = progress.querySelector('[data-workshop-progress-label]');
    const segments = Array.from(progress.querySelectorAll('[data-workshop-progress-segment]'));
    const targets = segments
      .map((segment) => {
        const target = document.querySelector(segment.dataset.progressTarget);
        return target ? { segment, target } : null;
      })
      .filter(Boolean);

    if (!label || targets.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      const visibleEntry = entries.find((entry) => entry.isIntersecting);
      if (!visibleEntry) return;

      const active = targets.find(({ target }) => target === visibleEntry.target);
      if (!active) return;

      const activeIndex = segments.indexOf(active.segment);

      segments.forEach((segment, index) => {
        segment.classList.toggle('is-active', segment === active.segment);
        segment.classList.toggle('is-complete', index <= activeIndex);
      });

      label.textContent = `${active.segment.dataset.progressNumber} / ${targets.length} - ${active.segment.dataset.progressLabel}`;
    }, {
      root: null,
      rootMargin: '-35% 0px -55% 0px',
      threshold: 0
    });

    targets.forEach(({ target }) => observer.observe(target));
  };

  document.querySelectorAll('[data-workshop-progress]').forEach(initWorkshopProgress);

  document.addEventListener('shopify:section:load', (event) => {
    event.target
      .querySelectorAll('[data-workshop-progress]')
      .forEach(initWorkshopProgress);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["workshop-how-its-made"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      console.warn("GSAP/ScrollTrigger not loaded for Workshop component.");
      // Fallback
      document.querySelectorAll('.workshop .gsap-fade-up').forEach(el => {
        el.style.opacity = '1';
        el.style.transform = 'none';
      });
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    function initWorkshop() {
      // 1. Hero Content Initial Fade In
      const heroContent = document.querySelector('.js-workshop-hero-content');
      if (heroContent) {
        gsap.fromTo(heroContent, 
          { opacity: 0, y: 40 },
          { opacity: 1, y: 0, duration: 1.2, ease: "power3.out" }
        );
      }

      // 2. Pillars Grid Stagger
      const pillarsGrid = document.querySelector('#workshop-pillars-' + document.querySelector('.workshop').dataset.sectionId);
      const pillars = document.querySelectorAll('.js-workshop-pillar');
      
      if (pillars.length > 0 && pillarsGrid) {
        gsap.to(pillars, {
          scrollTrigger: {
            trigger: pillarsGrid,
            start: "top 85%"
          },
          opacity: 1,
          y: 0,
          duration: 0.8,
          stagger: 0.15,
          ease: "power2.out"
        });
      }

      // 3. Process Header Fade Up
      const processHeader = document.querySelector('.js-workshop-process-header');
      if (processHeader) {
        gsap.to(processHeader, {
          scrollTrigger: {
            trigger: processHeader,
            start: "top 85%"
          },
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.out"
        });
      }

      // 4. Timeline Steps Stagger
      const processSection = document.querySelector('.workshop__timeline');
      const steps = document.querySelectorAll('.js-workshop-step');
      
      if (steps.length > 0 && processSection) {
        gsap.to(steps, {
          scrollTrigger: {
            trigger: processSection,
            start: "top 80%"
          },
          opacity: 1,
          x: 0, 
          y: 0, // Fallback from base translateY
          duration: 0.8,
          stagger: 0.2, // Slightly slower stagger for vertical list
          ease: "back.out(1.2)" // Bumpy mechanical pop
        });
      }
    }

    document.addEventListener("shopify:section:load", (e) => {
      // Refresh triggers and re-init on theme editor save
      ScrollTrigger.refresh();
      initWorkshop();
    });

    // Slight delay to ensure layout is settled
    setTimeout(initWorkshop, 100);
  });

  } catch(e) { console.error(e); }
})();
})();
